export default {"src":"/_next/static/media/productsShop.defef289.JPG","height":1700,"width":1520,"blurWidth":0,"blurHeight":0};